<template>
  <section class="container text-center my-5">
    <h2>What Our Customers Say</h2>
    <div class="row mt-4">

      <div class="col-md-4">
        <img src="../../assets/img/testimonial-1.webp"/>
        <blockquote class="blockquote">
          <p>"Top service from CCF Fibreglass. Parts arrived well-packed, the finish was spot on, and they helped me choose the right fit for my model over the phone."</p>
          <footer class="blockquote-footer">Jane McAllister</footer>
        </blockquote>
      </div>

      <div class="col-md-4">
        <img src="../../assets/img/testimonial-2.webp"/>
        <blockquote class="blockquote">
          <p>"Brilliant quality and quick turnaround. The fairing lined up perfectly with minimal prep. Customer support kept me updated from order to delivery."</p>
          <footer class="blockquote-footer">Layla Bennett</footer>
        </blockquote>
      </div>

      <div class="col-md-4">
        <img src="../../assets/img/testimonial-3.webp"/>
        <blockquote class="blockquote">
          <p>"I’ve used a few suppliers and CCF are a step above. Strong moulds, clean edges, and great aftercare when I had a question about installation."</p>
          <footer class="blockquote-footer">Marco Petrescu</footer>
        </blockquote>
      </div>

    </div>
  </section>
</template>

<style scoped>
img {
  height: 60px;
  width: 60px;
  border-radius: 50%;
}
</style>
